<template>
  <base-dialog v-model="isVisible">
    <dialog-template>

      <div
        slot="title"
        v-text="displayTitle"
      />

      <!-- TODO: CPME-3895 доработать кастомизацию заголовка в DialogTemplate -->
      <!-- <div v-if="currentStep === 1" slot="title" :class="$style.title">
        <h2>{{ displayTitle }}</h2>
        <a v-if="isExternalCheckoutProvider" :class="$style.help" href="https://capusta.space/tariffs" target="_blank"></a>
      </div>

      <div v-if="currentStep === 2" slot="title" :class="$style.title">
        <h2>{{ displayTitle }}: <strong>{{ Math.abs(getDifference / 100) }} {{ currency }}</strong></h2>
        <a v-if="isExternalCheckoutProvider" :class="$style.help" href="https://capusta.space/tariffs" target="_blank"></a>
      </div>

      <div v-if="currentStep === 3" slot="title" :class="$style.title">
        <h2>{{ displayTitle }}</h2>
      </div> -->

      <template slot="content">
        <component
          :is="displayComponent"
          :loading="loading"
          @refund-debit="handleRefundDebit"
          @refund-bill="handleRefundBill"
          @change-data="handleChangeRefundData"
        />

        <div v-if="currentStep === 1" slot="footer" :class="$style.footer">
          <div :class="[$style.action, $style.submit]">
            <simple-button @click="nextStep">
              {{ $t('common.agree') }}
            </simple-button>
          </div>
          <div :class="$style.action">
            <simple-button variant="transparent" @click="close">
              {{ $t('common.cancel') }}
            </simple-button>
          </div>
        </div>

        <div v-if="currentStep === 2" slot="footer" :class="$style.footer">
          <simple-button variant="transparent" @click="close">
            {{ $t('common.cancel') }}
          </simple-button>
        </div>

        <div v-if="currentStep === 3" slot="footer" :class="$style.footer">
          <div :class="[$style.action, $style.submit]">
            <simple-button :disabled="isInvalid" @click="handleRefund">
              {{ $t('common.send') }}
            </simple-button>
          </div>
          <div :class="$style.action">
            <simple-button variant="transparent" @click="currentStep = 1">
              {{ $t('common.cancel') }}
            </simple-button>
          </div>
        </div>
      </template>

    </dialog-template>
  </base-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import BaseDialog from 'molecules/base/Dialog';
import SimpleButton from 'molecules/common/SimpleButton';
import RefundCommission from 'organisms/refund/modals/RefundCommission';
import BalanceReplenishment from 'organisms/refund/modals/BalanceReplenishment';
import IndicateReasonReturn from 'organisms/refund/modals/IndicateReasonReturn';
import DialogTemplate from 'templates/DialogTemplate';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'RefundConfirmModal',
  components: {
    BaseDialog,
    SimpleButton,
    RefundCommission,
    BalanceReplenishment,
    IndicateReasonReturn,
    DialogTemplate,
  },
  created() {
    EVENT_BUS.$on('REFUND_CONFIRM', this.loadRefundCommission);
  },
  beforeDestroy() {
    EVENT_BUS.$off('REFUND_CONFIRM', this.loadRefundCommission);
  },
  data() {
    return {
      currentStep: 1,
      refund: {
        reason: '',
        email: '',
        alert: false,
      },
      isVisible: false,
      loading: false,
    };
  },
  computed: {
    buttonWidth() {
      return this.isDesktop ? 'auto' : '100%';
    },
    displayTitle() {
      return this.$t(this.steps[this.currentStep].title);
    },
    displayComponent() {
      return this.steps[this.currentStep].component;
    },
    hasEnoughAmount() {
      return this.getCurrentProject.balance >= this.getTotalAmount;
    },
    getTotalAmount() {
      if (!this.data.commission) {
        return 0;
      }

      return this.data.amount + this.data.commission;
    },
    getDifference() {
      if (this.hasEnoughAmount) {
        return 0;
      }

      return this.getCurrentProject.balance - this.getTotalAmount;
    },
    isInvalid() {
      if (this.$validate.isEmptyString(this.refund.reason)) {
        return true;
      }

      if (this.refund.alert) {
        return !this.$validate.isEmail(this.refund.email);
      }

      return false;
    },
    getEmail() {
      if (!this.refund.alert) {
        return '';
      }

      return this.refund.email;
    },
    currency() {
      return this.getCurrentProject.currency;
    },
    ...mapState('refund', ['data', 'steps']),
    ...mapGetters([
      'isDesktop',
      'getCurrentProject',
      'isExternalCheckoutProvider',
      'SELECTED_TRANSACTION',
      'isDeviceSize',
    ]),
  },
  methods: {
    close() {
      this.$nextTick(this.clearState);
    },
    clearState() {
      this.isVisible = false;
      this.currentStep = 1;
      this.refund.reason = '';
      this.refund.email = '';
      this.refund.alert = false;
    },
    nextStep() {
      if (this.isExternalCheckoutProvider) {
        this.currentStep = 3;
        return;
      }

      if (this.hasEnoughAmount) {
        this.currentStep = 3;
        return;
      }

      this.currentStep = 2;
    },
    handleChangeRefundData(data) {
      this.refund = { ...data };
    },

    async handleRefund() {
      if (this.isInvalid) {
        this.$alert({
          type: 'warning',
          text: 'indicate.reason.for.refund',
        });
        return;
      }

      try {
        await this.refundSend({
          email: this.getEmail,
          transactionId: this.SELECTED_TRANSACTION.owner_id,
          reason: this.refund.reason,
        });

        this.$alert({
          type: 'success',
          text: 'refund.sent.successfully',
        });

        EVENT_BUS.$emit('CABINET_UPDATE');
      } catch (error) {
        this.$alert({
          type: 'warning',
          text: 'refund.not.sent',
        });
      }

      this.close();
    },
    async handleRefundDebit(cardId) {
      this.loading = true;

      try {
        await this.refundDebit({
          cardId,
          transactionId: this.SELECTED_TRANSACTION.owner_id,
        });

        this.$alert({
          type: 'golubok',
          text: 'balance.replenished',
        });
      } catch (error) {
        this.$alert({
          type: 'warning',
          text: 'balance.not.replenished',
        });
      } finally {
        this.loading = false;
        this.close();
      }
    },
    async handleRefundBill() {
      try {
        const data = await this.refundBill(this.SELECTED_TRANSACTION.public_id);

        this.$openLink(data.url, !this.isDeviceSize.mobilePlus);
      } catch (error) {
        this.$alert({
          type: 'warning',
          text: 'bill.not.created',
        });
      }

      this.close();
    },
    async loadRefundCommission(publicId) {
      try {
        await this.refundCommission(publicId);
        this.isVisible = true;
      } catch (error) {
        this.$alert({
          type: 'warning',
          text: 'data.not.loaded',
        });

        this.close();
      }
    },
    ...mapActions('refund', [
      'refundSend',
      'refundCommission',
      'refundDebit',
      'refundBill',
    ]),
  },
};
</script>

<style lang="sass" module>
  .title
    position: relative

    h2
      padding-right: 40px

  .help
    width: 30px
    height: 30px
    position: absolute
    top: 0
    right: 0
    background-image: url('~@/assets/img/icons/question.svg')
    background-repeat: no-repeat
    background-position: center
    cursor: pointer

  .footer
    margin-top: 20px
    display: flex
    flex-direction: column

    +respond-to(small)
      flex-direction: row
      justify-content: space-between

  .action
    flex-grow: 1
    overflow: hidden

    &:not(:last-child)
      margin: 0 0 20px

    +respond-to(small)
      &:not(:last-child)
        margin: 0 20px 0 0

  .submit
    min-width: 230px
</style>
